import React from 'react';
import spaces from 'settings/spaces';
import { borders } from 'settings';
import { fontSizes, lineHeights } from 'settings/typography';
import Box from 'libs/core-components/Box/Box';
import IconButton from 'microfrontend/common/components/IconButton';
import X1 from 'common/Icon/components/X1';

export interface BaseAlertProps {
    icon?: React.ReactNode;
    className?: string;
    children: React.ReactNode;
    onDismiss?: () => void;
    dismissed?: boolean;
}

export default function BaseAlert({
    className,
    children,
    icon,
    onDismiss,
    dismissed = false,
}: BaseAlertProps) {
    const hide = () => {
        if (onDismiss) {
            onDismiss();
        }
    };

    if (dismissed) return null;

    return (
        <Box
            display="flex"
            css={`
                padding: ${spaces.space6}px ${spaces.halfGutter}px;
                border-radius: ${borders.borderRadiuses.medium}px;
            `}
            className={className}
            data-testid={'BaseAlert'}
        >
            <Box marginRight="space6">{icon}</Box>
            <div
                css={`
                    line-height: ${lineHeights.root};
                    font-size: ${fontSizes.root}px;
                    margin: 0;
                    flex-grow: 1;
                `}
            >
                {children}
            </div>
            {onDismiss && (
                <Box marginLeft="space6">
                    <IconButton aria-label={__('Dismiss')} onClick={hide}>
                        <X1 />
                    </IconButton>
                </Box>
            )}
        </Box>
    );
}
